import { asyncComponent } from 'react-async-component';

const FoundryLayout = asyncComponent<{}>({
  resolve: () => import('./Layout').then(x => x.default)
});

export default FoundryLayout;
